import React from "react";

import { XAxis, YAxis, Cell, BarChart, Bar } from "recharts";

export default class MobileBarChart extends React.Component {
  render() {
    //ToDo, replace the native recharts Label with custom label
    //Recharts labels have overpowering pixel shade which makes text look blocky and strange
    const { barData } = this.props;
    const data = [
      {
        name: "Assumed",
        uv: barData.assumed ? (barData.percentage ? barData.assumed.toPrecision(2) : barData.assumed) : 0
      },
      {
        name: "Actual",
        uv: barData.actual ? (barData.percentage ? barData.actual.toPrecision(2) : barData.actual) : 0
      }
    ];

    const colors = ["#7E69D7", "#EF7E54"];

    return (
      <BarChart
        width={300}
        height={100}
        data={data}
        layout="vertical"
        isAnimationActive={false}
        barGap={200}
        barCategoryGap={25}
      >
        <XAxis axisLine={false} tick={false} type="number" />
        <YAxis type="category" dataKey="name" />
        <Bar label={{ fill: "white", fontSize: 20 }} dataKey="uv" fill="#7E69D7" barGap>
          {" "}
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} stroke={colors[index]} />
          ))}
        </Bar>
      </BarChart>
    );
  }
}
